import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
  ComplexFormSchemaComponents,
} from "../../../../../components/types";
import {
  selectIncidentStatementsData,
  selectIsPoliceStatementSelected,
  selectIsPerpetratorStatementSelected,
} from "../incident.selectors";
import { setStatementType } from "../incident.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<
  SimpleFormSchemaComponents | ComplexFormSchemaComponents
> = {
  formId: FormId.INCIDENT_STATEMENTS,
  selector: selectIncidentStatementsData,
  content: [
    {
      title: "Oświadczenia",
      sections: [
        {
          id: "incident-statements-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.INCIDENT_STATEMENTS_TYPE,
              required: true,
              label: "Jaki dokument został sporządzony na miejscu zdarzenia?",
              onChange: setStatementType,
              items: [
                {
                  label: "oświadczenie sprawcy",
                  value: "perpetrator",
                },
                {
                  label: "protokół policji",
                  value: "police",
                },
              ],
            },
          ],
        },
        {
          id: "incident-statements-data-2",
          wrapper: { xs: 12 },
          isVisible: selectIsPoliceStatementSelected,
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_STATEMENTS_POLICE_DEPARTMENT,
              required: true,
              label: "Jednostka policji",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_STATEMENTS_CASE_NUMBER,
              required: true,
              label: "Numery sprawy",
            },
          ],
        },
        {
          id: "incident-statements-data-3",
          title:
            "Dodaj zdjęcie oświadczenia sprawcy, jeśli je posiadasz (maksymalnie 10 plików)",
          wrapper: { xs: 12 },
          isVisible: selectIsPoliceStatementSelected,
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.INCIDENT_STATEMENTS_POLICE_IMAGES,
              maxImageNumber: 10,
              imageSectionId: ComponentId.INCIDENT_STATEMENTS_POLICE_IMAGES,
            },
          ],
        },
        {
          id: "incident-statements-data-4",
          title:
            "Dodaj zdjęcie oświadczenia sprawcy, jeśli je posiadasz (maksymalnie 10 plików)",
          wrapper: { xs: 12 },
          isVisible: selectIsPerpetratorStatementSelected,
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_IMAGES,
              maxImageNumber: 10,
              imageSectionId:
                ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_IMAGES,
            },
          ],
        },
      ],
    },
  ],
};
